import { c as _c } from "react/compiler-runtime";
import Close from '../../../icons/Close';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../Tooltip';
interface MultiSelectClearButtonProps {
  label: string;
  onClear: () => void;
  /** `data-testid` is `${testId}-clear`. */
  testId?: string;
}
function isDisabledByFieldset(element: HTMLSpanElement) {
  return element.closest('fieldset:disabled') !== null;
}

/**
 * Inline clear affordance for a filter trigger that is itself a `<button>` — Popover and Select
 * triggers both are, and a nested button is invalid HTML, so this is a `role="button"` span whose
 * activation stops propagating rather than also opening the trigger's popover. Keyboard users can
 * reach the same action from a Clear control inside the popover.
 */
export function MultiSelectClearButton(t0) {
  const $ = _c(15);
  const {
    label,
    onClear,
    testId
  } = t0;
  let t1;
  if ($[0] !== onClear) {
    t1 = function handleKeyDown(event) {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }
      if (isDisabledByFieldset(event.currentTarget)) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      onClear();
    };
    $[0] = onClear;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleKeyDown = t1;
  const t2 = testId ? `${testId}-clear` : undefined;
  const t3 = `Clear ${label}`;
  let t4;
  if ($[2] !== onClear) {
    t4 = event_0 => {
      if (isDisabledByFieldset(event_0.currentTarget)) {
        return;
      }
      event_0.stopPropagation();
      onClear();
    };
    $[2] = onClear;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Close className="size-4" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== handleKeyDown || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t6 = <TooltipTrigger asChild={true}><span role="button" data-testid={t2} tabIndex={0} aria-label={t3} onClick={t4} onKeyDown={handleKeyDown} className="text-secondary-foreground hover:text-foreground focus-visible:inset-ring-ring -mr-1.5 flex size-6.5 shrink-0 cursor-pointer items-center justify-center rounded-md outline-none focus-visible:inset-ring-2">{t5}</span></TooltipTrigger>;
    $[5] = handleKeyDown;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `Clear ${label}`;
  let t8;
  if ($[10] !== t7) {
    t8 = <TooltipContent>{t7}</TooltipContent>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <TooltipProvider><Tooltip>{t6}{t8}</Tooltip></TooltipProvider>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}